var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 0 48 48" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.25 16.278a.648.648 0 01.662-.4l.106.02 9.162 2.455c.672.086 1.268.129 1.79.129.528 0 1.131-.044 1.811-.131l.001-.006 9.108-2.44a.647.647 0 01.767.38.604.604 0 01-.3.775c-5.346 2.125-8.128 3.677-8.346 4.657-.326 1.47-.49 2.105-.49 3.285 0 2.994.888 3.622.95 3.685l7.372 6.278c.244.208.283.57.09.825a.648.648 0 01-.744.215l-.096-.046-8.166-4.714A4.658 4.658 0 0024 30.814c-.653 0-1.296.142-1.938.428l-8.164 4.717a.647.647 0 01-.84-.17.604.604 0 01.09-.824l7.374-6.281c.062-.062.972-.667.972-3.682 0-1.304-.148-1.921-.442-3.23-.197-.872-3.03-2.446-8.502-4.72a.603.603 0 01-.3-.774zM24 11a3 3 0 110 6 3 3 0 010-6z" })));
});
